<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{
          Object.entries(this.data).length === 0
            ? "Adicionar Novo"
            : "Atualizar"
        }}
        Cliente
      </h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-4">
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              name="idIlux"
              class="w-full"
              type="number"
              label-placeholder="Código Ilux"
              v-model="idIlux"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('idIlux')">{{
              errors.first("idIlux")
            }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              name="stateRegistration"
              class="w-full"
              label-placeholder="Inscrição Estadual"
              v-model="stateRegistration"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/1 w-full mb-2">
            <vs-input
              label="Razão Social"
              v-model="corporateName"
              class="mt-5 w-full"
              name="corporateName"
              v-validate="'required'"
            /><span
              class="text-danger text-sm"
              v-show="errors.has('corporateName')"
              >{{ errors.first("corporateName") }}</span
            >
            <vs-input
              label="Nome Fantasia"
              v-model="fantasyName"
              class="mt-5 w-full"
              name="fantasyName"
            />
          </div>
        </div>
        <br />
        <div class="vx-row">
          <div class="vx-col sm:w-1/1 w-full mb-2">
            <label for="datepicker">Data de Fundação</label>
            <div>
              <datepicker
                name="foundationDate"
                id="datepicker"
                placeholder="Selecione a Data"
                :language="languages['ptBR']"
                format="dd/MM/yyyy"
                v-model="foundationDate"
                 v-validate="'required'"
              ></datepicker>
            </div>
            <span class="text-danger text-sm" v-show="errors.has('foundationDate')">{{
              errors.first("foundationDate")
            }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              name="cpf"
              class="w-full"
              type="text"
              label="CPF"
              v-model="cpf"
            />
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input name="cnpj" class="w-full" label="CNPJ" v-model="cnpj" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/1 w-full mb-2">
            <vs-input
              label="Cidade/Estado Ex: IJUÍ(RS)"
              v-model="city"
              class="mt-5 w-full"
              name="city"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('city')">{{
              errors.first("city")
            }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/1 w-full mb-2">
            <vs-input
              label="Endereço"
              v-model="address"
              class="mt-5 w-full"
              name="address"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/1 w-full mb-2">
            <vs-input
              label="Bairro"
              v-model="district"
              class="mt-5 w-full"
              name="district"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/1 w-full mb-2">
            <vs-input
              label="CEP"
              v-model="cep"
              class="mt-5 w-full"
              name="cep"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              name="ddd"
              class="w-full"
              type="text"
              label="DDD"
              v-model="ddd"
             v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('ddd')">{{
              errors.first("ddd")
            }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              name="phone"
              class="w-full"
              label="Telefone"
              v-model="phone"
            />
          </div>
        </div>
        <vs-input
          label="Email"
          type="mail"
          v-model="mail"
          class="mt-5 w-full"
          name="mail"
        />
        <vs-input
          label="Email 2"
          type="mail2"
          v-model="mail2"
          class="mt-5 w-full"
          name="mail2"
        />
         <div class="vx-row">
                <div class="vx-col md:w-1/1 w-full mt-5"> <h6 class="mb-2">É inadimplente?</h6></div>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-1/1 w-full mt-5">
                  <ul class="demo-alignment">
                    <li>
                      <vs-radio
                        color="danger"
                        v-model="defaulter"
                        vs-value="Y"
                        >Sim</vs-radio
                      >
                    </li>
                    <li>
                      <vs-radio
                        color="success"
                        v-model="defaulter"
                        vs-value="N"
                        >Não</vs-radio
                      >
                    </li>
                  </ul>
                </div>
              </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button
        class="mr-6"
        type="filled"
        color="success"
        @click="submitData()"
        :disabled="!isFormValid"
        icon-pack="feather"
        icon="icon-save"
        >Salvar</vs-button
      >
      <vs-button
        type="filled"
        color="danger"
        icon-pack="feather"
        icon="icon-x"
        @click="isSidebarActiveLocal = false"
        >Cancelar</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { Validator } from "vee-validate";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
const dict = {
  custom: {
    corporateName: {
      required: "Por favor insira a razão social",
      alpha: "Your first name may only contain alphabetic characters",
    },
    idIlux: {
      required: "Por favor insira o Código do ILUX",
      alpha: "Your first name may only contain alphabetic characters",
    },
    city: {
      required: "Por favor insira cidade/estado",
      alpha: "Your first name may only contain alphabetic characters",
    },
    foundationDate: {
      required: "Por favor insira a data de fundação",
      alpha: "Your first name may only contain alphabetic characters",
    },
    ddd: {
      required: "Por favor insira o ddd",
      alpha: "Your first name may only contain alphabetic characters",
    },
  },
};

// register custom messages
Validator.localize("en", dict);
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else {
        //console.log(this.data);
        /*let { category, id, img, name, order_status, price } = JSON.parse(
          JSON.stringify(this.data)
        );*/
        // let {idIlux} = JSON.parse(JSON.stringify(this.data))

        this.idIlux = this.data.idIlux;
        this.stateRegistration = this.data.stateRegistration;
        this.corporateName = this.data.corporateName;
        this.fantasyName = this.data.fantasyName;
        this.cpf = this.data.cpf;
        this.cnpj = this.data.cnpj;
        this.city = this.data.city;
        this.address = this.data.address;
        this.district = this.data.district;
        this.cep = this.data.cep;
        this.ddd = this.data.ddd;
        this.phone = this.data.phone;
        this.mail = this.data.mail;
        this.mail2 = this.data.mail2;
        this.defaulter = this.data.defaulter;
        this.foundationDate = this.data.foundationDate;
        this.initValues();
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    },
  },
  data() {
    return {
      idIlux: "",
      stateRegistration: "",
      corporateName: "",
      fantasyName: "",
      cpf: "",
      cnpj: "",
      city: "",
      address: "",
      district: "",
      cep: "",
      ddd: "",
      phone: "",
      mail: "",
      mail2: "",
      defaulter :"",
      foundationDate: "",
      languages: lang,
      customer: {},
      settings: {
        // perfectscrollbar settings i
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      backgroundLoading: "primary",
      colorLoading: "#fff",
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    isFormValid() {
      return (
        !this.errors.any() && this.corporateName && this.idIlux > 0 && this.city
      );
    },
  },
  methods: {
    initValues() {
      if (this.data.idCustomer) return;
      this.idIlux = "";
      this.stateRegistration = "";
      this.corporateName = "";
      this.fantasyName = "";
      this.cpf = "";
      this.cnpj = "";
      this.city = "";
      this.address = "";
      this.district = "";
      this.cep = "";
      this.ddd = "";
      this.phone = "";
      this.mail = "";
      this.mail2 = "";
      this.defaulter = "N";
      this.foundationDate = "";
    },
    async submitData() {
      let result = this.$validator.validateAll();
      this.stateRegistration = this.stateRegistration
        ? this.stateRegistration.toUpperCase()
        : this.stateRegistration;
      this.fantasyName = this.fantasyName
        ? this.fantasyName.toUpperCase()
        : this.fantasyName;
      this.address = this.address ? this.address.toUpperCase() : this.address;
      this.district = this.district
        ? this.district.toUpperCase()
        : this.district;
      this.city = this.city ? this.city.toUpperCase() : this.city;

       // Verificar se pelo menos CPF ou CNPJ está preenchido
      if (!this.cpf && !this.cnpj) {
        this.$vs.notify({
          color: "danger",
          title: "Erro de Validação",
          text: "Por favor, insira o CPF ou CNPJ.",
        });
        return; // Impedir que o formulário seja submetido
      }


      if (result) {
        this.customer = {
          idCustomer: this.data.idCustomer,
          corporateName: this.corporateName.toUpperCase(),
          stateRegistration: this.stateRegistration,
          fantasyName: this.fantasyName,
          cpf: this.cpf,
          cnpj: this.cnpj,
          city: this.city,
          address: this.address,
          district: this.district,
          cep: this.cep,
          ddd: this.ddd,
          phone: this.phone,
          idIlux: this.idIlux,
          mail: this.mail,
          mail2: this.mail2,
          defaulter: this.defaulter,
          foundationDate: this.foundationDate,
        };
        let payload = {
          customer: this.customer,
          notify: this.$vs.notify,
          loading: this.$vs.loading,
        };

        if (this.data.idCustomer !== null && this.data.idCustomer >= 0) {
          this.$store.dispatch("customers/updateCustomer", payload);
        } else {
          delete this.customer.idCustomer;
          this.$store.dispatch("customers/addNewCustomer", payload);
        }

        this.$emit("closeSidebar");
      }
    },
  },
  components: {
    VuePerfectScrollbar,
    Datepicker,
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
